var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auto-container"},[_c('BotSettingsForm',{attrs:{"form-type":"create","data":_vm.initialState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }